export default __webpack_public_path__ + "static/media/6.bc4bd425.jpg";